import { POST } from '@wellsfargo/ecpfs-authority'

export const EMAIL_PATH = 'register/email.json'

export function fetchEmailConfirmation(email, contextByBrandId) {
	const emailPathByContext = `${contextByBrandId}/${EMAIL_PATH}`
	return POST(emailPathByContext, email)
}
